'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');

// Returns the Terms of Service info (currently the timestamp) for the application.

var KayleeTosInfo = {
    fromJson: fromJson,
	get: getTosInfo,
};

function fromJson(data) {
    var reqProps = [];
    return FirebaseObject.$fromJson(data, 'TosInfo', reqProps, reqProps,
        function(data) { return getTosInfo(); }
    );
}

// Returns a TosInfo object. 

function getTosInfo() {
    var key = 'TosInfo';
    var tosInfo = KayleeCache.get(key);

    if (tosInfo === null) {
        tosInfo = new TosInfo();
        KayleeCache.put(key, tosInfo);
    }

    return tosInfo;
}

function TosInfo() {
    this.$nodeType = 'tosInfo';
    FirebaseObject.call(this,
        KayleeBase.app.database().ref('tos/info'));
}

TosInfo.prototype = Object.create(FirebaseObject.prototype);
TosInfo.prototype.constructor = TosInfo;

TosInfo.prototype.$toJson = function() {
    return FirebaseObject.prototpe.$toJson.call(this, [], {});
};

TosInfo.prototype.toString = function() {
    return '[TosInfo]';
};

module.exports = KayleeTosInfo;